// extracted by mini-css-extract-plugin
module.exports = {"fixedWidth":"style__fixedWidth__LOvC7"};